/**
 * @file 布丁
 */

// 安卓输入键盘弹起
if (/Android/gi.test(navigator.userAgent)) {
  window.addEventListener('resize', function () {
    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      window.setTimeout(function () {
        document.activeElement.scrollIntoViewIfNeeded();
      }, 0);
    }
  });
}

window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) { event.preventDefault() }
  });
  document.addEventListener('gesturestart', function(event) { event.preventDefault() });
  document.body.addEventListener('touchstart', function () {});
};